// src/components/PrivateRoute.js
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "../firebase";

const PrivateRoute = ({ children }) => {
    console.log("AUTH USER:", auth.currentUser);

    const [user, loading] = useAuthState(auth);
    console.log("useAuthState USER:", user, "LOADING:", loading);
    

  if (loading) return <div>Loading...</div>;

  return user ? children : <Navigate to="/login" />;
};

export default PrivateRoute;
